import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import Page from 'modules/Page';
import * as parentConstants from 'modules/user-admin/UsersAreaPage/constants';
import * as constants from './constants';

const NewUserPage = lazyWithSuspense(() => import('./NewUserPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage({
    WrappedPage: NewUserPage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: parentConstants.USER_ACCOUNTS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
